import React from 'react';
import { ArrowRight, TrendingUp } from 'lucide-react';
import { Link } from 'react-router-dom';
import CTASection from '../components/sections/CTASection';

const CaseStudies: React.FC = () => {
  const caseStudies = [
    {
      challenge: "Struggling to attract high-net-worth professionals and maintain consistent lead flow",
      solution: "Implemented AdvisorGrow's lead capture system and automated email nurture campaigns",
      results: [
        "185% increase in qualified leads",
        "42 new clients in 12 months",
        "68% reduction in lead response time",
        "4.9 average Google rating"
      ],
      quote: "AdvisorGrow transformed my practice. The automated systems freed up my time while consistently bringing in high-value clients."
    },
    {
      challenge: "Needed to scale practice while maintaining personal touch with clients",
      solution: "Utilized AdvisorGrow's CRM and review management system",
      results: [
        "312% growth in AUM over 24 months",
        "97% client retention rate",
        "52 five-star reviews generated",
        "3.5x increase in referrals"
      ],
      quote: "The review management system has been a game-changer. The steady stream of authentic reviews has significantly boosted our credibility and referral rate."
    },
    {
      challenge: "Wanted to establish authority in a specific market niche",
      solution: "Leveraged AdvisorGrow's content marketing and landing page tools",
      results: [
        "243% increase in website conversions",
        "76 new clients acquired",
        "156% growth in newsletter subscribers",
        "$14.2M in new AUM from digital marketing"
      ],
      quote: "AdvisorGrow helped me build a powerful digital presence that resonates with my target market. The results have exceeded my expectations."
    }
  ];

  return (
    <div className="animate-fade-in">
      {/* Hero Section */}
      <section className="section bg-primary text-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl mb-6 text-white">
              Success Stories
            </h1>
            <p className="text-xl text-white/90">
              See how financial advisors are transforming their practices with AdvisorGrow.
            </p>
          </div>
        </div>
      </section>

      {/* Case Studies */}
      <section className="section">
        <div className="container-custom">
          <div className="space-y-12">
            {caseStudies.map((study, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl shadow-xl overflow-hidden p-8 lg:p-12"
              >
                <div className="space-y-6">
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900">The Challenge</h4>
                    <p className="mt-2 text-gray-600">{study.challenge}</p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-900">The Solution</h4>
                    <p className="mt-2 text-gray-600">{study.solution}</p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-900">Key Results</h4>
                    <ul className="mt-4 space-y-3">
                      {study.results.map((result, i) => (
                        <li key={i} className="flex items-start">
                          <TrendingUp className="h-5 w-5 text-primary mt-0.5 mr-2" />
                          <span className="text-gray-600">{result}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <blockquote className="border-l-4 border-primary pl-4 italic text-gray-600">
                    "{study.quote}"
                  </blockquote>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
};

export default CaseStudies;